import { render, staticRenderFns } from "./searchItemList.vue?vue&type=template&id=36a2aaf6&scoped=true&"
var script = {}
import style0 from "./searchItemList.vue?vue&type=style&index=0&id=36a2aaf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2aaf6",
  null
  
)

export default component.exports